import { Col, Row, Form } from "react-bootstrap";
import RefreshIcon from "@mui/icons-material/Refresh";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import {
  TextField,
  Grid,
  Checkbox,
  FormControlLabel,
  Tooltip,
  InputAdornment,
  ListItem,
} from "@mui/material";
import "./Users.css";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import {
  getCountryAndMarket,
  saveUsersData,
  resetPassword,
  checkDuplicateUser,
  nonDfinPasswordResest,
} from "../../api/usersApi/usersApi";
import { useLoader } from "../../context/LoaderContext";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import "react-datepicker/dist/react-datepicker.css";
import { useSnackbar } from "../Common/SnackbarContext";
import ConfirmationDialog from "../SimpleSearch/ConfirmationDialog";
import LocalStorageUtil from "../../utils/localStorage";

function not(a: readonly number[], b: readonly number[]) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a: readonly number[], b: any) {
  return b.filter((group: any) => a.includes(group.groupId));
}

interface UsersActionsProps {
  businessUnitData: any;
}
export interface DialogProps {
  dialogTitle: string;
  contentText: string;
  confirmText: string;
  closeText: string;
  onConfirm: (() => Promise<void>) | null;
}
const UsersActions: React.FC<UsersActionsProps> = ({ businessUnitData }) => {
  const location = useLocation();
  const navigation = useNavigate();
  const [isAllowUser, setIsAllowUser] = useState(false);
  const { rowData, action } = location.state || {};
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const [searchTerm, setSearchTerm] = useState("");
  const [history, setHistory] = useState<
    Array<{
      left: readonly number[];
      right: readonly number[];
      checked: readonly number[];
    }>
  >([]);
  const [data, setData] = useState<any>([]);
  const [checked, setChecked] = React.useState<readonly number[]>([]);
  const [left, setLeft] = useState<readonly number[]>([]);
  const [country, setCountry] = useState<any>([]);
  const [state, setState] = useState<any>([]);
  const [market, setMarket] = useState<any>([]);
  const [groups, setGroups] = useState<any>([]);
  const [right, setRight] = useState<any>([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [apiMessage, setApiMessage] = useState("");
  const [isActive, setIsActive] = useState(rowData?.active);
  
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
    const [dialogProps, setDialogProps] = useState<DialogProps>({
      dialogTitle: "",
      contentText: "",
      confirmText: "",
      closeText: "",
      onConfirm: null,
    });

  const formatDate = (date: any) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    countryName: country[0]?.countryName || "",
    stateName: state[0]?.stateName || "",
    marketName: market[0]?.marketName || "",
    groupName: groups[0]?.groupName || "",
    emailId: rowData?.emailId || "",
    isApiUser: rowData?.isAPIUser || false,
    firstName: rowData?.firstName || "",
    middleName: rowData?.middleName || "",
    lastName: rowData?.lastName || "",
    userName: rowData?.userName || "",
    phone: rowData?.phone || "",
    mobile: rowData?.mobile || "",
    address1: rowData?.address1 || "",
    address2: rowData?.address2 || null,
    countryId: rowData?.countryId || "",
    stateId: rowData?.stateId || "",
    marketId: rowData?.marketId || "",
    groupId: rowData?.primaryGroupId || "",
    city: rowData?.city || "",
    postalCode: rowData?.postalCode || "",
    expireDate: formatDate(rowData?.expireDate) || "",
    userId: rowData?.userId || LocalStorageUtil.getItem("userId"),
  });

  const [formErrors, setFormErrors] = useState({
    emailId: "",
    firstName: "",
    lastName: "",
    userName: "",
    officePhone: "",
    address1: "",
    country: "",
    state: "",
    city: "",
    postalCode: "",
    market: "",
    primaryGroup: "",
  });

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: number) => () => {
    saveToHistory();
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    saveToHistory();
    setLeft(left.concat(right));
    setRight([]);
  };

  const saveToHistory = () => {
    setHistory((prev) => [...prev, { left, right, checked }]);
  };

  const undoLastAction = () => {
    if (history.length > 0) {
      const lastState = history[history.length - 1];
      setLeft(lastState.left);
      setRight(lastState.right);
      setChecked(lastState.checked);
      setHistory((prev) => prev.slice(0, -1));
    }
  };

  const customList = (items: readonly number[]) => (
    <Paper sx={{ width: "100%", height: 490, overflow: "auto" }}>
      <List dense component="ul">
        {items.length === 0 ? (
          <ListItemText sx={{ textAlign: "center", color: "gray" }}>
            No items available...
          </ListItemText>
        ) : (
          items?.map((value: any) => {
            const isSelected = checked.indexOf(value.groupId) !== -1;
            return (
              <ListItem component="li" key={value?.groupId}>
                <ListItemButton
                  onClick={handleToggle(value.groupId)}
                  sx={{
                    backgroundColor: isSelected
                      ? "rgb(77, 123, 167)"
                      : "transparent",
                    border: isSelected ? "1px solid darkblue" : "",
                    color: isSelected ? "white" : "default",
                    "&:hover": {
                      backgroundColor: isSelected ? "darkblue" : "lightgray",
                    },
                  }}
                >
                  <ListItemText primary={value.groupName} />
                </ListItemButton>
              </ListItem>
            );
          })
        )}
      </List>
    </Paper>
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    if (type === "checkbox") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if (name === "emailId") {
      validateEmail(value);
    } else if (
      name === "firstName" ||
      name === "lastName" ||
      name === "middleName"
    ) {
      validateText(value, name);
    }
  };

  const validateEmail = (email: any) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email.match(emailPattern)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "Please enter a valid email address.",
      }));
      return false;
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        emailId: "",
      }));
      return true;
    }
  };

  const validateText = (text: string, fieldName: keyof typeof formErrors) => {
    const textPattern = /^[a-zA-Z\s]+$/;
    if (!textPattern.exec(text)) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "Please enter alphabets only",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    validateEmail(formData.emailId);
    if (formErrors.emailId) {
      return;
    }
  };
  const validateFields = (fields: any) => {
    const hasErrors = (errorObject: Record<string, string>): boolean => {
      return Object.values(errorObject).some((value) => value.trim() !== "");
    };

    let errorObject = {
      emailId: "",
      firstName: "",
      lastName: "",
      userName: "",
      officePhone: "",
      address1: "",
      country: "",
      state: "",
      city: "",
      postalCode: "",
      market: "",
      primaryGroup: "",
    };
    if (!fields.EmailId || !validateEmail(fields.EmailId))
      errorObject.emailId = "Please enter a valid Email";
    if (!fields.FirstName) errorObject.firstName = "Please enter First Name";
    if (!fields.LastName) errorObject.lastName = "Please enter Last Name";
    if (!fields.UserName) errorObject.userName = "Please enter Username";
    if (!fields.Phone) errorObject.officePhone = "Please enter Office Phone";
    if (!fields.Address1) errorObject.address1 = "Please enter Address";
    if (!fields.StateId) errorObject.state = "Please select State";
    if (!fields.City) errorObject.city = "Please enter City";
    if (!fields.PostalCode) errorObject.postalCode = "Please enter Postal Code";
    if (fields.MarketId <= 0) errorObject.market = "Please select Market";
    if (fields.PrimaryGroupId <= 0 && action !== "Edit")
      errorObject.primaryGroup = "Please select Primary Group";
    setFormErrors(errorObject);
    debugger;
    return !hasErrors(errorObject);
  };
  useEffect(() => {
    if (data && data.length > 0) {
      setFormData({
        countryName: country[0]?.countryName || "",
        stateName: state[0].stateName || "",
        marketName: market[0].marketName || "",
        groupName: groups[0].groupName || "",
        emailId: rowData?.emailId || "",
        isApiUser: rowData?.isAPIUser || false,
        firstName: rowData?.firstName || "",
        middleName: rowData?.middleName || "",
        lastName: rowData?.lastName || "",
        userName: rowData?.userName || "",
        phone: rowData?.phone || "",
        mobile: rowData?.mobile || "",
        address1: rowData?.address1 || "",
        address2: rowData?.address2 || null,
        countryId: rowData?.countryId || "",
        stateId: rowData?.stateId || "",
        marketId: rowData?.marketId || "",
        groupId: rowData?.groupId || "",
        postalCode: rowData?.postalCode || "",
        city: rowData?.city || "",
        expireDate: formatDate(rowData?.expireDate) || "",
        userId: rowData?.userId || LocalStorageUtil.getItem("userId"),
      });
    }
  }, [data, rowData]);

  const getCountryAndMarketData = async () => {
    setLoading(true);
    const payload = {
      contextNameForUser:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName"),
    };
    try {
      const data = await getCountryAndMarket(payload);
      setData(data);
      setLeft(data.lstGroupModel);
      setCountry(data.lstCountryModel);
      setState(data.lstStateModel);
      setMarket(data.lstMarketModel);
      setGroups(data.lstGroupModel);
      if (action === "Edit" || action === "Duplicate") {
        const userGroupIds = new Set(
          rowData.userGroup.map((group: any) => group.groupId)
        );
        const filteredLeft = data.lstGroupModel.filter(
          (group: any) => !userGroupIds.has(group.groupId)
        );
        const filteredRight = data.lstGroupModel.filter((group: any) =>
          userGroupIds.has(group.groupId)
        );
        setLeft(filteredLeft);
        setRight(filteredRight);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDialogClose = (confirm: boolean) => {
    try {
      setConfirmDialogOpen(false);
      if (confirm) {
        navigate("/user");
      } else {
        setConfirmDialogOpen(false);
      }
    } catch (error) {
      console.error("Error in handleConfirmDialogClose", error);
    }
  };

  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  const handlePassowrd = async () => {
    try {
      setLoading(true);
      if (rowData.isAPIUser) {
        const payload = {
          accountId:
            Number(businessUnitData?.accountId) ||
            Number(LocalStorageUtil.getItem("accountId")),
          businessUnitId:
            Number(businessUnitData?.businessUnitId) ||
            Number(LocalStorageUtil.getItem("businessUnitId")),
          contextName:
            businessUnitData?.contextName ||
            LocalStorageUtil.getItem("contextName"),
          emailId: formData.emailId,
          firstName: formData.firstName,
          lastName: formData.lastName,
          userId:
            Number(formData.userId) || Number(LocalStorageUtil.getItem("userId")),
          userName: formData.userName,
        };
        const response = await resetPassword(payload);
        if (response.responseCode === 200) {
          setApiMessage(response.resetUrl);
        } else if (
          response.responseCode === 500 ||
          response.responseCode === 400
        ) {
          setApiMessage(response.error);
        }
        setApiMessage(
          "This is an API User. Password Reset Email has been sent"
        );
      } else if (rowData.isNonDfinUser) {
        const payload = {
          contextName:
            businessUnitData?.contextName ||
            LocalStorageUtil.getItem("contextName"),
          email: formData.emailId,
        };

        const response = await nonDfinPasswordResest(payload);
        if (response.responseCode === 200) {
          setApiMessage(response.resetUrl);
        } else if (
          response.responseCode === 500 ||
          response.responseCode === 400
        ) {
          setApiMessage(response.error);
        }
      }
    } catch (error) {
      console.log("error found", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountryAndMarketData();
  }, []);

  const handleSave = async () => {
    setLoading(true);
    const userGroupIds = (right || []).map((g: any) => g.groupId);
    const userGroupAccountIds = (right || []).map((g: any) => g.accountId);
    const optionFlag = (() => {
      switch (action) {
        case "Edit":
          return "edit";
        case "Duplicate":
          return "copy";
        default:
          return 0;
      }
    })();
    const payload = {
      ContextNameForUser: LocalStorageUtil.getItem("contextName"),
      businessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
      isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
      AllowUser: isAllowUser ? 1 : 0,
      objUserModel: {
        UserId: action === "Edit" ? rowData?.userId : 0,
        UserName: formData.userName,
        FirstName: formData.firstName,
        MiddleName: formData.middleName,
        LastName: formData.lastName,
        EmailId: formData.emailId,
        mobile: formData.mobile === "" ? undefined : formData.mobile,
        Phone: formData.phone,
        Address1: formData.address1,
        Address2: formData.address2 === "" ? undefined : formData.address2,
        City: formData.city,
        StateId: Number(formData.stateId),
        PostalCode: formData.postalCode,
        PrimaryGroupId: Number(formData?.groupId),
        MarketId: Number(formData.marketId),
        ExpireDate: formData.expireDate,
        Language: "English",
        AccountId: Number(LocalStorageUtil.getItem("accountId")),
        UserGroupIDList: JSON.stringify(userGroupIds),
        UserGroupAccountIdlist: JSON.stringify(userGroupAccountIds),
        PrimaryGroupAccountId: Number(LocalStorageUtil.getItem("accountId")),
        createdby: Number(LocalStorageUtil.getItem("userId")),
        active: action === "Edit" || action === "Duplicate" ? isActive : true,
        // "optionflag": action === "Edit" ? "edit" : action === "Duplicate" ? "copy" : 0,
        optionflag: optionFlag,
        CreatedDate: action === "Edit" ? rowData?.createdDate : undefined,
        Domainname: action === "Edit" ? null : undefined,
        IsAPIUser: formData.isApiUser,
      },
    };
    try {
      if (validateFields(payload.objUserModel)) {
        const response = await saveUsersData(payload);
        if (response === "UserId") {
          showSnackbar("User Name already exists", true);
        } else if (response !== "Error") {
          if (action === "Edit") {
            showSnackbar("User has been updated successfully");
          } else {
            showSnackbar("User has been Created Successfully");
          }
          navigation("/user");
        }
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleDataFill = async (data: any) => {
    setDialogOpen(false);
    setFormData({
      countryName: country[0]?.countryName || "",
      stateName: data.stateId || "",
      marketName: data.marketId || "",
      groupName: groups[0].groupName || "",
      emailId: data?.emailId || "",
      isApiUser: data?.isAPIUser || false,
      firstName: data.firstName || "",
      middleName: data?.middleName || "",
      lastName: data?.lastName || "",
      userName: data?.userName || "",
      phone: data?.phone || "",
      mobile: data?.mobile || "",
      address1: data?.address1 || "",
      address2: data?.address2 || null,
      countryId: data?.countryId || "",
      stateId: data?.stateId || "",
      marketId: data?.marketId || "",
      groupId: data?.groupId || "",
      postalCode: data?.postalCode || "",
      city: data?.city || "",
      expireDate: formatDate(data?.expireDate) || "",
      userId: data?.userId || LocalStorageUtil.getItem("userId"),
    });
  };
  const handleEmailBlur = async () => {
    const contextname = LocalStorageUtil.getItem("contextName");
    const email = formData.emailId;
    const businessUnitId = LocalStorageUtil.getItem("businessUnitId");

    const response = await checkDuplicateUser({
      ContextNameForUser: contextname,
      objUserModel: {
        businessUnitId: businessUnitId,
        IsSuperAdmin: "1",
        UserName: email,
      },
    });
    if (response.userValidation === "duplicateMailId") {
      setFormErrors({
        emailId: "EmailId Already Exists",
        firstName: "",
        lastName: "",
        userName: "",
        officePhone: "",
        address1: "",
        country: "",
        state: "",
        city: "",
        postalCode: "",
        market: "",
        primaryGroup: "",
      });
      setIsAllowUser(false);
    } else if (response.userValidation === "ExistsUserAnotherAccount") {
      const data = response.objUserModel;
      setIsAllowUser(true);
      console.log(data);
      setDialogProps({
        dialogTitle: " Confirm user add",
        contentText:
          "User already exists in another account, Do you want to add to this Account?",
        confirmText: "Yes",
        closeText: "No",
        onConfirm: () => handleDataFill(data),
      });
      setDialogOpen(true);
    }
  };
  const handleStatusChange = () => {
    setIsActive((prevIsActive: any) => {
      const updatedStatus = !prevIsActive;
      return updatedStatus;
    });
  };

  return (
    <div style={{ overflow: "hidden" }}>
      {action === "Edit" ? (
        <NavigationBar  menuTitle="Configuration"
        title="User Management" screenTitle="Users" text="Users - Edit" />
      ) : (
        <NavigationBar  menuTitle="Configuration"
        title="User Management" screenTitle="Users" text="Users - Create New User" />
      )}
      <div className="ag-theme-quartz-dark" style={{ marginLeft: "4vh" }}>
        <div
          className="col-sm-5"
          style={{
            width: "97%",
            textAlign: "right",
            margin: "10px",
          }}
        >
          {action === "Edit" && (
            <Tooltip
              title={
                rowData.active
                  ? "Click to make the user inactive"
                  : "Click to make the user active"
              }
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isActive}
                    onChange={handleStatusChange}
                    color="primary"
                    size="small"
                  />
                }
                label={isActive ? "Active" : "In-Active"}
                style={{
                  margin: "1px 3px",
                  textTransform: "none",
                  fontSize: "11px",
                  color: isActive ? "#154360" : "#7B241C",
                  backgroundColor: isActive ? "#D6EAF8" : "#FADBD8",
                  padding: "3px 6px",
                  borderRadius: "3px",
                  alignItems: "center",
                  height: "2.5em",
                }}
              />
            </Tooltip>
          )}
        </div>
        <h4
          className="form-heading"
          style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
        >
          BASIC INFORMATION
        </h4>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Email
                <p style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required">
                    *
                </p>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="user@email.com"
                  name="emailId"
                  onBlur={handleEmailBlur}
                  disabled={action === "Edit"}
                  value={formData.emailId || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.emailId}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.emailId && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.emailId}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group
                controlId="formApiUser"
                style={{ marginTop: "1.9rem" }}
              >
                <Form.Check
                  type="checkbox"
                  label="Is API User?"
                  name="isApiUser"
                  checked={formData.isApiUser}
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                  disabled={action === "Edit"}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  First Name
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the First Name"
                  name="firstName"
                  value={formData.firstName || ""}
                  onChange={handleChange}
                  isInvalid={!!formErrors.firstName}
                  required
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.firstName && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.firstName}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Middle Name
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the Middle Name"
                  name="middleName"
                  value={formData.middleName || ""}
                  onChange={handleChange}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Last Name
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the Last Name"
                  name="lastName"
                  value={formData.lastName || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.lastName}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.lastName && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.lastName}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <h4
            className="form-heading"
            style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
          >
            Contact Information
          </h4>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  User Name
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the User Name"
                  name="userName"
                  value={formData.userName || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.userName}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />

                {formErrors.userName && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.userName}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Office Phone
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Office Phone"
                  name="phone"
                  value={formData.phone || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.officePhone}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.officePhone && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.officePhone}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Mobile
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Mobile Number"
                  name="mobile"
                  value={formData.mobile || ""}
                  onChange={handleChange}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-12">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Address 1
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address1"
                  name="address1"
                  value={formData.address1 || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.address1}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.address1 && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.address1}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Address 2
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Address2"
                  name="address2"
                  value={formData.address2 || ""}
                  onChange={handleChange}
                  required
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Country
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Select
                  name="countryId"
                  value={formData.countryId}
                  onChange={handleChange}
                  className="select-dropdown"
                  style={{ fontSize: "11px" }}
                >
                  <option value="">Select Country</option>
                  {country.map((country: any) => (
                    <option key={country.countryId} value={country.countryId}>
                      {country.countryName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  State / Province
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Select
                  name="stateId"
                  value={formData.stateId}
                  onChange={handleChange}
                  isInvalid={!!formErrors.state}
                  className="select-dropdown"
                  style={{ fontSize: "11px" }}
                >
                  <option value="">Select State</option>
                  {state.map((state: any) => (
                    <option key={state.stateId} value={state.stateId}>
                      {state.stateName}
                    </option>
                  ))}
                </Form.Select>
                {formErrors.state && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.state}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  City
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.city}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.city && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.city}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formGroupName">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Postal Code
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Postal Code"
                  name="postalCode"
                  value={formData.postalCode || ""}
                  onChange={handleChange}
                  required
                  isInvalid={!!formErrors.postalCode}
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
                {formErrors.postalCode && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.postalCode}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label className="input-labels" style={{fontSize: "11px"}}>
                  Market{" "}
                  <span
                    className="required"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    *
                  </span>
                </Form.Label>
                <Form.Select
                  name="marketId"
                  value={formData.marketId}
                  onChange={handleChange}
                  isInvalid={!!formErrors.market}
                  className="select-dropdown"
                  style={{ fontSize: "11px" }}
                >
                  <option value="">Select Market</option>
                  {market.map((market: any) => (
                    <option key={market.marketId} value={market.marketId}>
                      {market.marketName}
                    </option>
                  ))}
                </Form.Select>

                {formErrors.market && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.market}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <h4
            className="form-heading"
            style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
          >
            Group Information
          </h4>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formCustomer">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  Primary Group
                  <p
                    style={{ color: "var(--aggrid-text-color)", display: "contents" }}
                    className="required"
                  >
                    *
                  </p>
                </Form.Label>
                <Form.Select
                  name="groupId"
                  value={formData?.groupId}
                  onChange={handleChange}
                  className="select-dropdown"
                  isInvalid={!!formErrors.primaryGroup}
                  style={{ fontSize: "11px" }}
                >
                  <option value="">Select Primary Group</option>
                  {groups.map((account: any) => (
                    <option key={account.groupId} value={account.groupId}>
                      {account.groupName}
                    </option>
                  ))}
                </Form.Select>

                {formErrors.primaryGroup && (
                  <Form.Control.Feedback type="invalid">
                    {formErrors.primaryGroup}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Label
                className="input-labels"
                style={{ color: "var(--aggrid-text-color)", fontSize: "11px" }}
              >
                Groups
              </Form.Label>
              <TextField
                variant="outlined"
                placeholder="Search..."
                fullWidth
                onChange={handleSearchChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  bgcolor: "white",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    height: "30px",
                    borderRadius: "8px",
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#888",
                    },
                    "& input": {
                      fontSize: "11px",
                    },
                  },
                }}
              />
            </Col>
          </Row>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "left",
              alignItems: "left",
              fontSize: "11px",
            }}
          >
            <Grid item md={3} />
            <Grid item>
              {customList(
                left.filter((item: any) =>
                  item.groupName
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                )
              )}
            </Grid>
            <Grid item style={{ width: "100px" }}>
              <Grid container direction="column" sx={{ alignItems: "center" }}>
                <Button
                  sx={{ my: 0.5, height: "25px" }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllRight}
                  disabled={left.length === 0}
                  aria-label="move all right"
                  className="arrow-button"
                >
                  ≫
                </Button>
                <Button
                  sx={{ my: 0.5, height: "25px" }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedRight}
                  disabled={leftChecked.length === 0}
                  aria-label="move selected right"
                  className="arrow-button"
                >
                  &gt;
                </Button>
                <Button
                  sx={{ my: 0.5, height: "25px" }}
                  variant="outlined"
                  size="small"
                  onClick={handleCheckedLeft}
                  disabled={rightChecked.length === 0}
                  aria-label="move selected left"
                  className="arrow-button"
                >
                  &lt;
                </Button>
                <Button
                  sx={{ my: 0.5, height: "25px" }}
                  variant="outlined"
                  size="small"
                  onClick={handleAllLeft}
                  disabled={right.length === 0}
                  aria-label="move all left"
                  className="arrow-button"
                >
                  ≪
                </Button>
                <Button
                  sx={{ my: 0.5, height: "25px" }}
                  variant="outlined"
                  size="small"
                  onClick={undoLastAction}
                  disabled={history.length === 0}
                  aria-label="undo last action"
                  className="arrow-button"
                >
                  <RefreshIcon fontSize="small" 
    sx={{ 
      fontSize: "14px",
      height: "14px",
      width: "14px"
    }} />
                </Button>
              </Grid>
            </Grid>
            <Grid item>{customList(right)}</Grid>
          </Grid>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formDate">
                <Form.Label
                  className="input-labels"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  User Account Expiry Date<span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="expireDate"
                  value={formData.expireDate}
                  onChange={handleChange}
                  onClick={(e) => (e.target as HTMLInputElement).showPicker()}
                  required
                  className="input-box"
                  style={{ fontSize: "11px" }}
                />
              </Form.Group>
            </Col>
          </Row>
          {(rowData?.isAPIUser === true || rowData?.isNonDfinUser === true) && (
            <Row lassName="mb-3">
              <Col md={9}>
                <Form.Group controlId="formGroupName">
                  <Form.Control
                    type="text"
                    value={apiMessage || ""}
                    onChange={handleChange}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>
          )}
          <Grid
            item
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              mb: 2,
            }}
          >
            {(rowData?.isAPIUser === true ||
              rowData?.isNonDfinUser === true) && (
              <Button
                variant="contained"
                className="passwordreset-button"
                style={{
                  marginRight: "10px",
                  fontSize: "11px",
                  borderRadius: "4px",
                  border: "1px solid #858c94",
                  height: "25px",
                  minWidth: "170px"
                }}
                onClick={handlePassowrd}
              >
                Password Reset
              </Button>
            )}
            {action === "Edit" ? (
              <Button
                variant="contained"
                className="update-button"
                onClick={handleSave}
                style={{
                  fontSize: "11px",
                  borderRadius: "4px",
                  border: "1px solid #858c94",
                  height: "25px",
                }}
              >
                Update
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                className="update-button"
                onClick={handleSave}
                style={{
                  fontSize: "11px",
                  borderRadius: "4px",
                  border: "1px solid #858c94",
                  height: "25px",
                }}
              >
                Create
              </Button>
            )}
            <Button
              variant="contained"
              className="cancel-button"
              onClick={handelCancel}
              style={{
                fontSize: "11px",
                borderRadius: "4px",
                border: "1px solid #858c94",
                height: "25px",
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Form>
      </div>
      <ConfirmDialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        title={`Users -  ${action === "Edit" ? "Update User" : "Create User"}`}
        content="Are you sure you want to Cancel?"
      />
      <ConfirmationDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={dialogProps.onConfirm}
        contentText={dialogProps.contentText}
        closeText={dialogProps.closeText}
        confirmText={dialogProps.confirmText}
        dialogTitle={dialogProps.dialogTitle}
      />
    </div>
  );
};

export default UsersActions;
